package com.vizio.redwolf.auth.model

import kotlinx.serialization.Serializable
import kotlin.js.JsExport

@Serializable
@JsExport
data class LoginResponse(
    val token: String,
    val refreshToken: String,
    val expiration: String,
    val hasPasswordStrong: Boolean,
    val user: AccountUser
)